/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetEULAAccepted: BridgeCommands.Command<
    Types.Common.Nvaccount.GetEULAAcceptedParameters,
    Types.Common.Nvaccount.GetEULAAcceptedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'GetEULAAccepted',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetEULAAccepted: BridgeCommands.Command<
    Types.Common.Nvaccount.SetEULAAcceptedParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'SetEULAAccepted',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OnLogin: BridgeCommands.Command<
    Types.Common.Nvaccount.OnLoginParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'OnLogin',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OnLogout: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'OnLogout',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUserAccount: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.GetUserAccountReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'GetUserAccount',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIdToken: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.GetIdTokenReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'GetIdToken',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RefreshConsent: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.ConsentLevel
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'RefreshConsent',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUserId: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.GetUserIdReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'GetUserId',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UserIdChangedNotification: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.UserIdChangedNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'UserIdChangedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UserConsentChangedNotification: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.UserConsentChangedNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'UserConsentChangedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetPrivacySettings: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.GetPrivacySettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'GetPrivacySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetPrivacySettings: BridgeCommands.Command<
    Types.Common.Nvaccount.SetPrivacySettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'SetPrivacySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetPrivacySettingsConsentInformation: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.GetPrivacySettingsConsentInformationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'GetPrivacySettingsConsentInformation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PrivacySettingsConsentInformationChangedNotification: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.PrivacySettingsConsentInformationChangedNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'PrivacySettingsConsentInformationChangedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PrivacySettingsChangedNotification: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.PrivacySettingsChangedNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'PrivacySettingsChangedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUserAccountAndDeviceConsent: BridgeCommands.Command<
    {},
    Types.Common.Nvaccount.GetUserAccountAndDeviceConsentReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvAccount',
    method: 'GetUserAccountAndDeviceConsent',
    persistent: false
};

export const Nvaccount = {
GetEULAAccepted,
SetEULAAccepted,
OnLogin,
OnLogout,
GetUserAccount,
GetIdToken,
RefreshConsent,
GetUserId,
UserIdChangedNotification,
UserConsentChangedNotification,
GetPrivacySettings,
SetPrivacySettings,
GetPrivacySettingsConsentInformation,
PrivacySettingsConsentInformationChangedNotification,
PrivacySettingsChangedNotification,
GetUserAccountAndDeviceConsent
};
